import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    id: null,
    email: "",
    name: "",
    firstName: "",
    lastName: "",
    photo: "",
    provider: "",
    location: null,
    preferences: {},
    properties: [],
    personTypeId: ""
  } as any,
  reducers: {
    setUser: (state, action) => {
      state.provider = action.payload.provider;
      state.name = action.payload.name;
      state.id = action.payload.id;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.preferences = action.payload.preferences;
      state.properties = action.payload.properties;
      state.personTypeId = action.payload.personTypeId;
      state.email = action.payload.email;
      state.blocks = action.payload.blocks;
    },
    setPreferences: (state,action) => {
      state.preferences = action.payload;
    },
    addProperty: (state,action) => {
      state.properties.push(action.payload);
    },
    removeProperty: (state, action) => {
      state.properties = state.properties.filter((p: any) => p.id !== action.payload.id);
    },
    editProperty: (state, action) => {
      const propIndex = state.properties.findIndex((p: any) => p.id === action.payload.id);
      state.properties[propIndex] = action.payload;

    },
  },
});

export const { setUser, setPreferences, addProperty, removeProperty, editProperty } = userSlice.actions;

export default userSlice.reducer;
